import clsx from "clsx";
import { ArrowUp } from "lucide-react";

interface SendButtonProps {
  variant: "cyan" | "magenta";
  disabled?: boolean;
  pending?: boolean;
  onPointerDown?: React.PointerEventHandler<HTMLButtonElement>;
}

export function SendButton({
  variant,
  disabled,
  pending,
  onPointerDown,
}: SendButtonProps): JSX.Element {
  const activeBg = variant === "cyan" ? "bg-cyber-cyan" : "bg-cyber-magenta";
  const disabledBg = "bg-cyber-surface/60";

  return (
    <button
      type="submit"
      disabled={disabled}
      onPointerDown={onPointerDown}
      className={clsx(
        "inline-flex h-9 w-9 items-center justify-center rounded-full transition-colors",
        disabled
          ? clsx(disabledBg, "cursor-not-allowed text-cyber-muted/60")
          : clsx(activeBg, "text-white hover:opacity-90"),
        pending && "opacity-90",
      )}
      aria-label="Send"
      title="Send"
    >
      {pending ? <span className="animate-spin-glow inline-block">◐</span> : <ArrowUp size={16} />}
    </button>
  );
}
